import { CampaignDetails, GetCampaignsByTagResponse } from "../types/CampaignAdminTypes"

/**
 * Maps a `GetCampaignsByTagResponse` to an array of `CampaignDetails`.
 *
 * This function extracts the `_source` field from each hit in the response,
 * assuming the response follows the structure `{ hits: { hits: [...] } }`.
 * It returns an array of campaign details directly from each hit.
 *
 * @param {GetCampaignsByTagResponse} response - The response object containing Elasticsearch-style hit results.
 * @returns {CampaignDetails[]} An array of `CampaignDetails` extracted from the `_source` field of each hit.
 *
 */
export const mapGetProductsByCampaignIdResponseToCampaignDetails = (
    response: GetCampaignsByTagResponse,
): CampaignDetails[] => {
    return response.hits.hits.map(hit => hit["_source"])
}
